import axios from 'axios';
import pages from './pages';
import news from './news';
import user from './user';
import events from './events';
import volunteers from './volunteers';
import auth from './auth';
import participants from './participants';
import sliderImages from './sliderImages';
import { API_ROOT } from '../constants/index';

axios.defaults.baseURL = API_ROOT;
axios.defaults.headers.post['Content-Type'] = 'application/json';


const resources = {
  pages,
  news,
  events,
  auth,
  sliderImages,
  volunteers,
  participants,
  user
};

export const doRequest = (requestName, args = {}) => {
  const exploded = requestName.split('.');
  const resourceName = exploded[0];
  const restName = exploded[1];
  return resources[resourceName][restName](args);
};

export const doMultipleRequest = (request, args = {}) => {
  const promises = [];
  request.forEach((requestName) => {
    const exploded = requestName.split('.');
    const resourceName = exploded[0];
    const restName = exploded[1];
    const promise = resources[resourceName][restName](args)
      .then(data => ({
        data,
        restName,
      }));
    promises.push(promise);
  });

  return Promise.all(promises)
    .then((data) => {
      return data;
    });
};

export default resources;